import axios from 'axios';
import { endpoints } from '@/api/endpoints.js';
import { baseURL } from '../../../api/environment';

const URL = baseURL;

/**
 * Obtiene el estado del envío
 */
export const sendStatusShipping = async ({ commit, getters, rootState }) => {
    try {
        commit('SET_LOADING', true);
        const token = rootState.Token.token.dataObj;
        const endpoint = endpoints.checkout.sendStatusShipping.endpoint;
        const subscriber = await getters.getFolio;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                "folio": subscriber.dataObj.folio,
            }
        });

        commit('SET_SHIPPING_INFORMATION', data.dataObj);
    } catch (err) {
        commit('SET_LOADING', false);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Envía la información de envío
 */
export const sendShipping = async ({ commit, rootState, getters }) => {
    try {
        commit('SET_LOADING', true);
        const token = rootState.Token.token.dataObj;
        const endpoint = endpoints.checkout.sendShipping.endpoint;
        const subscriber = await getters.getFolio;

        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                "folio": subscriber.dataObj.folio,
            }
        });
        
        if (Object.keys(data.dataObj).length != 0) {
            if (data.dataObj.codigo_respuesta == 222) {
                commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje_respuesta);
                commit('SET_LOADING', false);
            } else {
                return true;
            }
        } else {
            commit('SET_LOADING', false);
            commit('SET_ERROR_SUBSCRIPTION', data.msg);
        }
    } catch (err) {
        commit('SET_LOADING', false);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
